import { EventView } from '@ndvr/customer-api';

export type CalendarEventType = 'client' | 'internal';

// An event with no clientHouseholdGUID is an internal meeting — this mirrors the backend's own
// rule (TranscriptService.isClientMeeting). The field is typed non-optional in the generated TS
// but is null at runtime for internal events, so it is checked as falsy. Date-span (multi-day)
// events count as internal even when they have a household, so the filter and the card color
// always agree.
export const getCalendarEventType = (
    event: Pick<EventView, 'clientHouseholdGUID' | 'dateSpan' | 'isDateSpan'>,
): CalendarEventType => (event.clientHouseholdGUID && !event.dateSpan && !event.isDateSpan ? 'client' : 'internal');

// The one rule for the Client/Internal segment filter (null = no filter, everything shows),
// shared by the calendar and meeting-minutes tabs so the two views can't drift.
export const matchesEventTypeFilter = (
    event: Pick<EventView, 'clientHouseholdGUID' | 'dateSpan' | 'isDateSpan'>,
    filter: CalendarEventType | null,
): boolean => !filter || getCalendarEventType(event) === filter;

// Card treatment per event type — the look-and-feel ticket swaps tokens here.
export const CALENDAR_EVENT_TYPE_CARD_CLASSES: Record<CalendarEventType, string> = {
    client: 'border-seafoam-100 bg-seafoam-100',
    internal: 'border-cocoa-200/80 bg-white',
};

// Reading-list card left rule per event type (prototype: --claro-aqua / --cocoa-30).
export const CALENDAR_EVENT_TYPE_RULE_CLASSES: Record<CalendarEventType, string> = {
    client: 'border-l-seafoam-300',
    internal: 'border-l-cocoa-200/80',
};
